import React, { useEffect, useState } from "react";
import { ParentLayout } from "../../../layout/parentLayout";
import NewSideBarParent from "../../../components/NewSideBarParent";
import Upvote from "../../../components/Upvote";
import { MenuItem, Select, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AddFormAndDisscussion } from "../../../Modals/AddFormAndDisscussion";
import { useGetContentQuery } from "../../../service/content";
import {
  CONTENT_TYPE,
  ForumType,
  TYPE_SUBJECT_LISTING,
} from "../../../constants/enums";
import { ForumTypeInterface } from "../../../types/General";
import Loader from "../../../constants/Loader";
import { TutorLayout } from "../../../layout/tutorLayout";
import NewSideBarTutor from "../../../components/NewSideBarTutor";
import { AddPromoCodeModal } from "../../../Modals/AddPromoModal";
import useAuth from "../../../hooks/useAuth";
import { useLazyGetSubjectsAndCategoryQuery } from "../../../service/auth";
import { useDebounce } from "../../../constants/useDebounce";

type Filter = {
  subject: string;
  category: string;
  search: string;
};

export const TutorFormdiscussion = () => {
  const user = useAuth();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [getSubjects] = useLazyGetSubjectsAndCategoryQuery();
  const [category, setCategory] = useState<any[]>([]);
  const [subjects, setSubjects] = useState<any[]>([]);
  const [filters, setFilters] = useState<Filter>({
    subject: "",
    category: "",
    search: "",
  });
  const [debounce, setDebounce] = useState<string>("");

  const fetchCategory = async () => {
    try {
      const res = await getSubjects({
        type: TYPE_SUBJECT_LISTING.CATEGORY,
      }).unwrap();
      if (res?.statusCode == 200) {
        setCategory(res?.data);
      }
    } catch (error: any) {}
  };

  const { data: ForumData, isLoading } = useGetContentQuery({
    type: ForumType.OTHERS,
    contentType: CONTENT_TYPE.FORUM,
    page: 1,
    limit: 100,
    ...(filters.subject ? { subjectId: filters.subject } : {}),
    ...(filters.category ? { categoryId: filters.category } : {}),
    ...(debounce ? { search: debounce } : {}),
  });
  const fetchSubjects = async () => {
    try {
      const res = await getSubjects({
        type: TYPE_SUBJECT_LISTING.SUBJECT,
        categoryId: filters.category,
      }).unwrap();
      if (res?.statusCode == 200) {
        setSubjects(res?.data);
      }
    } catch (error: any) {}
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  useEffect(() => {
    if (filters.category) {
      fetchSubjects();
    }
  }, [filters.category]);
useEffect(() => {
    const delay = 1500; // Debounce delay in milliseconds
    const timerId = setTimeout(() => {
      setDebounce(filters.search);
    }, delay);
    return () => {
      clearTimeout(timerId); // Clear the timeout on cleanup
    };
  }, [filters.search]);

  return (
    <TutorLayout className="role-layout">
      <Loader isLoad={isLoading} />
      <main className="content">
        <section className="uh_spc pSearchResult_sc home_wrp">
          <div className="conta_iner v2">
            <div className="mn_fdx">
              <NewSideBarTutor />
              <div className="mdl_cntnt">
                <div className="thoughts">
                  <div className="th_row">
                    <figure>
                      <img
                        src={user?.image || `/static/images/amelia.png`}
                        alt="amelia"
                      />
                    </figure>
                    <div className="input_group">
                      <TextField
                        hiddenLabel
                        placeholder="Got a question or something to share ?"
                        variant="filled"
                        value={filters.search}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            search: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <img
                      onClick={handleOpen}
                      width={30}
                      src="/static/images/plus.png"
                      alt="error"
                    />
                    <AddFormAndDisscussion
                      handleClose={handleClose}
                      handleOpen={handleOpen}
                      open={open}
                    />
                  </div>
                </div>

                <ul className="cstmm_tabs cstmmm_tabs_1">
                  <li>
                    <Select
                      value={filters.category}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          category: e.target.value,
                        }))
                      }
                      fullWidth
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select category
                      </MenuItem>
                      {category?.map((item) => {
                        return (
                          <MenuItem value={item?._id}>
                            {item?.name || "-"}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </li>
                  <li>
                    <Select
                      name="subject"
                      value={filters.subject}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          subject: e.target.value,
                        }))
                      }
                      fullWidth
                      disabled={!filters.category}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Subject
                      </MenuItem>
                      {subjects?.map((item) => {
                        return (
                          <MenuItem value={item?._id}>
                            {item?.name || "-"}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </li>
                  {filters?.category || filters?.subject || filters?.search ? (
                    <button
                      className="btn primary"
                      style={{ backgroundColor: "red" }}
                      onClick={() => {
                        setFilters({
                          category: "",
                          subject: "",
                          search: "",
                        });
                        setDebounce("");
                      }}
                    >
                      Reset Filters
                    </button>
                  ) : null}
                </ul>

                {ForumData?.data?.data?.map(
                  (item: ForumTypeInterface, i: number) => (
                    <Upvote key={i} data={item} />
                  )
                )}
              </div>
              <div className="sidebar_rt">
                <section className="side_menu_wrap unlock_bg ">
                  <div className="group">
                    <h4>Unlock Learning, Book Your Perfect Tutor Today!</h4>
                    <button>Book Now</button>
                  </div>
                  <figure>
                    <img
                      src={`/static/images/unlock_men.png`}
                      alt="unlock_men"
                    />
                  </figure>
                </section>
                <section className="side_menu_wrap  page_link">
                  <ul>
                    <li>
                      <a>About Us</a>
                    </li>
                    <li>
                      <a>Contact Us</a>
                    </li>
                    <li>
                      <a>Help Center</a>
                    </li>
                    <li>
                      <a>Terms & conditions</a>
                    </li>
                    <li>
                      <a>Privacy Policy</a>
                    </li>
                    <li>
                      <a>FAQ’s</a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
    </TutorLayout>
  );
};
